class ListController {}

const listComponentDefinition = {
    bindings: {
        item: '<',
        isEditing: '<?',
        onRemove: '&?',
    },
    controller: ListController,
    template: require('./list.component.html').trim(),
};

module.exports = {
    ListController,
    listComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/tiles/list.component.js